var map = {
	"./bg5.jpg": "./src/assets/img/bg5.jpg",
	"./de.jpg": "./src/assets/img/de.jpg",
	"./emilyz.jpg": "./src/assets/img/emilyz.jpg",
	"./en.jpg": "./src/assets/img/en.jpg",
	"./frazurich.jpg": "./src/assets/img/frazurich.jpg",
	"./header.jpg": "./src/assets/img/header.jpg",
	"./img_3115.jpg": "./src/assets/img/img_3115.jpg",
	"./james.jpg": "./src/assets/img/james.jpg",
	"./mike.jpg": "./src/assets/img/mike.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.jpg$";